import { Component, Input, Output, OnChanges, SimpleChanges, SimpleChange, EventEmitter } from '@angular/core';


@Component({
    selector: 'share-target-dialog',
	templateUrl: './share-target-dialog.component.html',
	styleUrls: ['./share-target-dialog.component.scss']
})
export class ShareTargetDialogComponent {

	@Input()
	public sharedItemGuid: string;

	@Input()
	public display: boolean;

	@Output()
	public displayChange: EventEmitter<any>;

	@Output()
	public onClose: EventEmitter<any>;

	constructor() {
		this.sharedItemGuid = "";
		this.display = false;
		this.displayChange = new EventEmitter<any>();
		this.onClose = new EventEmitter<any>();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		let change: SimpleChange = null;

		change = changes["display"];
		if (change) {
			if (this.display) {
			}
		}
	}

	public handleClose(): void {
		this.hideDialog();
		this.onClose.emit(true);
	}

	public onDialogHide(): void {
		this.handleClose();
	}

    public displayDialog() {
		this.display = true;
		this.displayChange.emit();
    }

    public hideDialog() {
        this.display = false;
		this.displayChange.emit();
    }

}
